export class Controller {

    /** @ngInject */
    constructor(DirectoriesResource) {
        this.DirectoriesResource = DirectoriesResource;
    }

    $onInit() {
    }

    deactivate() {
        this.isSaving = true;
        this.DirectoriesResource
            .deactivateActiveDirectoryAgent(this.resolve.companyId, this.resolve.directoryId)
            .then((directory) => this.close({$value: directory}))
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/connection/download-agent/download-agent.controller.js